/**
 * Handles tab focus
 *
 * @param {HTMLElement} element - element within which focus needs to be trapped
 * @param {HTMLElement} prevFocusableElement - last focusable element
 * @returns {Object} - methods/props
 */
const trapFocus = (element, prevFocusableElement = document.activeElement) => {
    const focusableEls = Array.from(
        element.querySelectorAll(
            'a[href]:not([disabled]), button:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), textarea:not([disabled])'
        )
    );
    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    firstFocusableEl.focus();

    /**
     * Click handler
     *
     * @param {Event} e - click event
     */
    const handleFocus = e => {
        const KEYCODE_TAB = 9;
        const isTabPressed = e.key === 'Tab' || e.code === KEYCODE_TAB;

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) {
            /* shift + tab */ if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } /* tab */ else {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    };

    element.addEventListener('keydown', handleFocus, true);

    return {
        /**
         * handles when container is removed
         */
        onClose: () => {
            element.removeEventListener('keydown', handleFocus, true);
            prevFocusableElement.focus();
        }
    };
};

export default trapFocus;
